import React from 'react'
import { DeviceImages } from './device-images'
import { DeviceNameAndBattery } from './device-name-and-battery'
import { DeviceBasicInfo } from './device-basic-info'
import { DeviceAdvancedInfo } from './device-advanced-info'
import { DeviceSectionGroup } from './device-section-group'
import { DeviceReports } from './device-reports'
import { Box } from '@material-ui/core'
import { useStyles } from './styles'
import { DeviceMoveHistoryCard } from './device-move-history'
import { DeviceBaitCard } from './device-bait-card'
import { DeviceGatewayCard } from './device-gateway-card'
import { DeviceBaitActivitiesCard } from './device-bait-activities-card'
import { DeviceBaitActivitiesChart } from './device-bait-activities-chart'
import { BaitDebounceNotice } from './bait-debounce-notice'

const DeviceOverview = ({ children }) => {
    const classes = useStyles()

    return <Box className={classes.container}>{children}</Box>
}

DeviceOverview.DeviceImages = DeviceImages
DeviceOverview.DeviceSectionGroup = DeviceSectionGroup
DeviceOverview.DeviceNameAndBattery = DeviceNameAndBattery
DeviceOverview.DeviceBasicInfo = DeviceBasicInfo
DeviceOverview.DeviceAdvancedInfo = DeviceAdvancedInfo
DeviceOverview.DeviceReports = DeviceReports
DeviceOverview.DeviceMoveHistory = DeviceMoveHistoryCard
DeviceOverview.DeviceBaitCard = DeviceBaitCard
DeviceOverview.DeviceGatewayCard = DeviceGatewayCard
DeviceOverview.DeviceBaitActivitiesCard = DeviceBaitActivitiesCard
DeviceOverview.DeviceBaitActivitiesChart = DeviceBaitActivitiesChart
DeviceOverview.BaitDebounceNotice = BaitDebounceNotice

export default DeviceOverview
